export default __webpack_public_path__ + "static/media/fixingGlass.6ac8e20c.jpg";